import type { RegisterNotificationParams } from './registerNotification';
import { registerNotification } from './registerNotification';
import { useEffectOnce } from 'react-use';

/**
 * @description This hook registers a notification event when nid is present in the URL params. The URL will then be updated to remove the nid param.
 * @returns void
 * @example useRegisterNotification({ ref: 'BROWSER_NEXT_SERVERLESS_DEMO_WEB' });
 * @param params ref: string
 * @warning This hook should only be used once per app, preferably on the App or whatever container component your app is using.
 */
export function useRegisterNotification(params: RegisterNotificationParams) {
  useEffectOnce(() => {
    registerNotification(params);
  });
}
